import { Add, Category } from "@mui/icons-material";
import { Box, Button, Divider, Stack, Tooltip, Typography } from "@mui/material";
import { DragEvent } from "react";
import { useTranslation } from "react-i18next";
import { FIELD_TYPE_GROUPS, builderFieldTypeLabelKey, getGroupedFieldTypes } from "../shared/FieldTypeRegistry";
import { PrmFieldType } from "../../types/formBuilder.types";

interface FieldPaletteProps {
    onAddField: (fieldType: PrmFieldType) => void;
}

export const PRM_FIELD_TYPE_MIME = "application/x-prm-field-type";

const FieldPalette = ({ onAddField }: FieldPaletteProps) => {
    const { t } = useTranslation();
    const groups = getGroupedFieldTypes();

    const handleDragStart = (event: DragEvent<HTMLButtonElement>, fieldType: PrmFieldType) => {
        event.dataTransfer.setData(PRM_FIELD_TYPE_MIME, fieldType);
        event.dataTransfer.effectAllowed = "copy";
    };

    return (
        <Box className="service-builder__palette">
            <Stack direction="row" spacing={1} alignItems="center" className="service-builder__panel-header">
                <Category fontSize="small" />
                <Typography variant="subtitle2">{t("Fields")}</Typography>
            </Stack>
            <Divider />
            <Box className="service-builder__palette-scroll">
                {FIELD_TYPE_GROUPS.map((group) => {
                    const fields = groups.get(group.key) || [];
                    if (!fields.length) return null;

                    return (
                        <Box key={group.key} className="service-builder__palette-group">
                            <Typography className="service-builder__group-label">{t(group.label)}</Typography>
                            <Box className="service-builder__palette-grid">
                                {fields.map((field) => (
                                    <Tooltip key={field.type} title={t(builderFieldTypeLabelKey(field.type, field.label), { defaultValue: field.label })}><Button
                                        className="service-builder__palette-item"
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Add />}
                                        draggable
                                        onDragStart={(event) => handleDragStart(event, field.type)}
                                        onClick={() => onAddField(field.type)}
                                    >
                                        <span className="service-builder__palette-item-label">{t(builderFieldTypeLabelKey(field.type, field.label), { defaultValue: field.label })}</span>
                                    </Button></Tooltip>
                                ))}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default FieldPalette;
